export default "__VITE_ASSET__DFLS0Skj__"